"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../utils");
var rawTo32Bit = function (key) {
    return utils_1.splitByLength(utils_1.paddStartZero(key, 16), 1).map(function (char) {
        return utils_1.decToHex(char.charCodeAt(0));
    });
};
exports.default = (function (transparent48v2) { return function (data) {
    var msgId = transparent48v2.virtual.msgId;
    var frame = ['48', '25', '01', utils_1.decToHex(msgId % 255)];
    var _a = transparent48v2.virtual.device, prodKey = _a.prodKey, devTid = _a.devTid;
    frame.push.apply(frame, rawTo32Bit(prodKey));
    frame.push.apply(frame, rawTo32Bit(devTid));
    return frame;
}; });



// WEBPACK FOOTER //
// ./src/transparent48v2/encode/1.ts